export default "__VITE_ASSET__xrHfx6d5__"